import { DateTimeTz } from "@web-app/components";
import { timeZoneMap } from "@web-app/utils/helpers";

function DateCell({
  value,
  timezone,
}: {
  timezone?: keyof typeof timeZoneMap;
  value: string;
}) {
  if (!value) {
    return "";
  }

  return (
    <>
      <DateTimeTz
        start={new Date(value)}
        timezone={timezone}
        popupPosition="right"
        presentation="columned"
      />
    </>
  );
}

export default DateCell;
